import { Autocomplete, Box, TextField } from '@mui/material';

function CatalogThumb({ src, alt = '', sx = {} }) {
  if (!src) {
    return (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1,
          bgcolor: '#f0f0f0',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 9,
          color: '#999',
          ...sx,
        }}
      >
        N/A
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: 48,
        height: 48,
        objectFit: 'cover',
        borderRadius: 1,
        flexShrink: 0,
        border: '1px solid #e0e0e0',
        bgcolor: '#fafafa',
        ...sx,
      }}
    />
  );
}

export default function AnprintCatalogPicker({ catalogs, valueId, onChange, disabled }) {
  const value = catalogs.find((c) => String(c.id) === String(valueId)) || null;

  return (
    <Autocomplete
      disabled={disabled}
      size="small"
      sx={{ minWidth: 280, flex: 1 }}
      options={catalogs}
      value={value}
      onChange={(_, catalog) => onChange(catalog ? catalog.id : '')}
      getOptionLabel={(c) => c.name || ''}
      isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
      noOptionsText="Không có catalog"
      renderOption={(props, catalog) => (
        <Box
          component="li"
          {...props}
          key={catalog.id}
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, px: 1 }}
        >
          <CatalogThumb src={catalog.thumbnail} alt={catalog.name} />
          <Box component="span" sx={{ fontSize: 13, lineHeight: 1.35, flex: 1 }}>
            {catalog.name}
            <Box component="span" sx={{ display: 'block', fontSize: 11, color: '#94a3b8' }}>
              {catalog.sku} · {(catalog.variants || []).length} variants
            </Box>
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Chọn loại fulfill (ảnh + tên)"
          InputProps={{
            ...params.InputProps,
            startAdornment: value ? (
              <>
                <CatalogThumb
                  src={value.thumbnail}
                  sx={{ width: 36, height: 36, borderRadius: 0.5, mr: 1, ml: 0.5 }}
                />
                {params.InputProps.startAdornment}
              </>
            ) : (
              params.InputProps.startAdornment
            ),
          }}
        />
      )}
    />
  );
}
